
/**
 * Module dependencies.
 */

import { ifProp, prop, theme } from 'styled-tools';
import styled, { css } from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  active: boolean;
  className?: string;
  size?: number;
  stroke?: number;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.span<{ active: boolean }>`
  display: block;
  transform: scale(0.5);
  transition: transform ${theme('animations.defaultTransition')};

  ${ifProp('active', css`
    transform: scale(1);
  `)}
`;

/**
 * `Loader` styled component.
 */

const Loader = styled.span<{ size: number; stroke: number }>`
  animation: ${theme('keyframes.spin')} 0.75s linear infinite;
  border-left-color: transparent;
  border-radius: ${prop('size')}px;
  border-style: solid;
  border-width: ${prop('stroke')}px;
  display: block;
  height: ${prop('size')}px;
  width: ${prop('size')}px;
`;

/**
 * Export `Spinner` component.
 */

export function Spinner(props: Props): JSX.Element {
  const { active, className, size = 24, stroke = 2, ...rest } = props;

  return (
    <Wrapper
      active={active}
      className={className}
    >
      <Loader
        {...rest}
        size={size}
        stroke={stroke}
      />
    </Wrapper>
  );
}
